// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : SANCTION REPORT
// MODIFIED DATE: 29-09-2025
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/*********** GET SANCTION REPORT START ****************** */
export const getSanctionReportDetails = (getData: any) => {
	const data = {
		GetSanctionReportDetailsToken: getData,
	};
	const url = `${API_URL}getLoanSanctionReport`;
	return makeApiCall(url, data);
};
/*********** GET SANCTION REPORT END ****************** */
